import React, { memo } from 'react'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormEmails__Details(props) {
    const { formik } = props

    return (
        <React.Fragment>
            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Template Name"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Template Name"} // placeholder for the input
                formikFieldName={"emailTemplateName"} // important: formik value name for the input
            />

            {/* form field */}
            <div className={`st-form st-form-with-label-left d-flex flex-wrap align-items-center ${(formik.touched.emailEventName && formik.errors.emailEventName) ? "has-msg msg-error" : ""}`}>
                <label>
                    Event Name
                    <span className="required">*</span>
                </label>
                <div className="media-body st-form-input-container">
                    <select
                        className="form-control"
                        id="emailEventName"
                        {...formik.getFieldProps('emailEventName')}>
                        <option disabled value="">Select Event Name</option>
                        {
                            (props.emailEvents && props.emailEvents.length) && props.emailEvents.map(item => (
                                <option
                                    key={item.event_id.toString()}
                                    value={item.event_id.toString()}>{item.event_title}</option>
                            ))
                        }
                    </select>
                    {
                        /* form message */
                        (formik.touched.emailEventName && formik.errors.emailEventName) && (
                            <div className="st-form-msg position-absolute">
                                <p className="st-fs-12">{formik.errors.emailEventName}</p>
                            </div>
                        )
                    }
                </div>
            </div>

            {/* form field */}
            <AppFormikSelectInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"To"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                formikFieldName={"emailTo"} // important: formik value name for the input
            >
                <option disabled value="">Select To</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
            </AppFormikSelectInline>

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"From"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"From"} // placeholder for the input
                formikFieldName={"emailFrom"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"Subject"} // label name
                isRequired={true} // is this field is required or not to show the red star sign
                placeholder={"Subject"} // placeholder for the input
                formikFieldName={"emailSubject"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"CC"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"CC"} // placeholder for the input
                formikFieldName={"emailCC"} // important: formik value name for the input
            />

            {/* form field */}
            <AppFormikInputInline
                formik={formik} // formik object
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center"} // class name for main wrapper
                labelName={"BCC"} // label name
                isRequired={false} // is this field is required or not to show the red star sign
                placeholder={"BCC"} // placeholder for the input
                formikFieldName={"emailBCC"} // important: formik value name for the input
            />


        </React.Fragment>
    )
}

export default memo(FormEmails__Details)